import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import LinearProgress from '@material-ui/core/LinearProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { Framework } from '@flint/framework';
import { inject, observer } from 'mobx-react';

const handleBackClick = () => {
    window.history.back();
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: theme.spacing(4),

    },
    paper: {
        width: '100%',
        height: "100%",
    },
    formTextField: {
        margin: theme.spacing(2, 0),
    },
    formFieldHidden:{
        display:"none",
    },
    formControl: {
        width: "100%",
        margin: theme.spacing(2, 0),
    },
    formControlLabel: {
        margin: (theme.spacing(2)),
        marginBottom: 0,
        "&:nth-child(1)": {
            marginLeft: 0,
        }
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    formButton: {
        color: "#FFF",
        padding: "15px",
        margin: theme.spacing(2, 0),
        fontSize: "18px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "20px",
        background: "#222747",
        borderRadius: "3px",
        textTransform: "uppercase",
        transition: "background 0.25s",
        border: "2px solid #222747",
        "&:hover": {
            background: "none",
            color: "#222747",
        },
    },
    formTitle: {
        fontFamily: "Merriweather",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "28px",
        lineHeight: "90px",
        color: "#222747",
    },
    backIcon: {
        height: "28px",
        width: "28px",
    }
}));

const EditTopicForm = ({ TopicStore, TopicEditStore, TopicEditStoreStatus }) => {
    const classes = useStyles();

    const [topicDet, setTopicDet] = React.useState({});
    const [editDialogOpen, setEditDialogOpen] = React.useState(false);

    const handleChange = (event) => {
        const key = event.target.name;
        const val = event.target.value;
        setTopicDet(prevState => {
            return { ...prevState, [key]: val }
        })
    }

    const handleSwitchChange = (event)  => {
        const key = event.target.name;
        setTopicDet(prevState => {
            return { ...prevState, [key]: !prevState[key] }
        })
    }

    const editTopicHandler = () => {
        Framework.sendEvent("EDITING_TOPIC_DATA", topicDet);
        setEditDialogOpen(true);
    }

    const handleEditDialogClose = () => {
        setEditDialogOpen(false);
    }

    React.useEffect(() => {
        document.title = "Edit Topic";
        window.scrollTo(0,0);
        Framework.sendEvent("FETCHING_TOPIC_DATA", `${window.location.pathname.split("/")[2]}`);
        setTopicDet(TopicStore);
    }, []);

    return (
        <>
            {TopicEditStoreStatus.isPending ? <LinearProgress color="secondary" /> : <Dialog
                open={editDialogOpen}
                onClose={handleEditDialogClose}
                aria-labelledby="sync-dialog-title"
                aria-describedby="sync-dialog-description"
            >
                <DialogTitle id="sync-dialog-title">Edit Topic</DialogTitle>
                <DialogContent>
                    <DialogContentText id="sync-dialog-description">
                        {TopicEditStore.res}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleEditDialogClose} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>}
            <div className={classes.root}>
                <Grid container spacing={3} justify="center">
                    <Grid item xs={12} sm={10} md={8} lg={6}>
                        <Paper className={classes.paper}>
                            <Tooltip title="Go back to Topic Table">
                                <IconButton onClick={handleBackClick}>
                                    <ArrowBackIcon className={classes.backIcon} />
                                </IconButton>
                            </Tooltip>
                            <form className={classes.root}>
                                <Typography className={classes.formTitle} variant="h1" id="tableTitle" component="div">Edit Topic Details</Typography>
                                <TextField className={classes.formTextField} id="isbn" label="ISBN" name="isbn" disabled
                                value={topicDet.isbn ? topicDet.isbn : ""} variant="outlined" fullWidth />
                                <TextField className={classes.formTextField} id="topicName" label="Topic Name" name="topicTitle" disabled
                                value={topicDet.topicTitle ? topicDet.topicTitle : ""} variant="outlined" fullWidth />
                                <FormControl className={classes.formControl}>
                                    <InputLabel id="selectGenus">Genus</InputLabel>
                                    <Select labelId="selectGenusLabel" id="selectGenus" multiple name="genus"
                                    value={topicDet.genus ? [...topicDet.genus] : []} onChange={handleChange} input={<Input id="selectGenusInput" />}
                                        renderValue={(selected) => (
                                            <div className={classes.chips}>
                                                {selected.map((value) => (
                                                    <Chip key={value} label={value} className={classes.chip} />
                                                ))}
                                            </div>
                                        )}
                                    >
                                        {[...TopicStore.genusMaster].map((genus) => (
                                            <MenuItem key={genus.genus} value={genus.genus}>
                                                {genus.genus}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" className={classes.formControl}>
                                    <InputLabel htmlFor="speciality">Speciality</InputLabel>
                                    <Select label="speciality" value={topicDet.specialty ? topicDet.specialty : ""} 
                                    name="specialty" onChange={handleChange}>
                                        {[...TopicStore.specialityMaster].map((speciality) => (
                                            <MenuItem key={speciality.speciality} value={speciality.speciality}>
                                                {speciality.speciality}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControlLabel className={classes.formControlLabel} control={<Switch checked={topicDet.top3 ? true : false} name="top3" value={topicDet.top3 ? true : false} onChange={handleSwitchChange} />} label="In Top three Topics" />
                                <FormControlLabel className={classes.formControlLabel} control={<Switch checked={topicDet.isFree ? true : false} name="isFree" value={topicDet.isFree ? true : false} onChange={handleSwitchChange} />} label="Free Topic" />
                                <Box display="flex" justifyContent="flex-end">
                                    <Button className={classes.formButton} variant="contained" color="primary"
                                    startIcon={<SaveIcon />} onClick={editTopicHandler}>Save Changes</Button>
                                </Box>
                            </form>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default inject('TopicStore', 'TopicEditStore', 'TopicEditStoreStatus')(observer(EditTopicForm));